"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _ConfigSelectors = require("pricing-pages-unified-ui/selectors/ConfigSelectors");

var EnvironmentWrapper = function EnvironmentWrapper(_ref) {
  var authedNode = _ref.authedNode,
      publicNode = _ref.publicNode,
      isAppAuth = _ref.isAppAuth;
  return isAppAuth ? authedNode : publicNode;
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    isAppAuth: (0, _ConfigSelectors.isAppAuthSelector)(state)
  };
};

EnvironmentWrapper.propTypes = {
  authedNode: _propTypes.default.node,
  publicNode: _propTypes.default.node,
  isAppAuth: _propTypes.default.bool.isRequired
};
EnvironmentWrapper.defaultProps = {
  authedNode: null,
  publicNode: null
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(EnvironmentWrapper);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/EnvironmentWrapper.js
// module id = 169
// module chunks = 5 6